import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c416e52c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c416e52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c416e52c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c416e52c')) {
      api.createRecord('c416e52c', component.options)
    } else {
      api.reload('c416e52c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c416e52c&scoped=true&", function () {
      api.rerender('c416e52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/comp/GuestBox.vue"
export default component.exports